import { render, staticRenderFns } from "./main-telinfo.vue?vue&type=template&id=2115b7ef&scoped=true&"
import script from "./main-telinfo.vue?vue&type=script&lang=js&"
export * from "./main-telinfo.vue?vue&type=script&lang=js&"
import style0 from "./main-telinfo.vue?vue&type=style&index=0&id=2115b7ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115b7ef",
  null
  
)

export default component.exports